<template>
  <div>
    <!-- /.box-header -->
    <section class="content-header" style="height: 50px;">
      <a v-if="!$root.isCustomer" href="#" @click="$root.showNewBox" style="float: left; padding-right: 10px;"><i class="fa fa-plus-circle" style="font-size: 30px;"></i></a>
      <input type="button" value="Get Demo History" @click="getDemoHistory()" v-if="0>1" />
      <input type="button" value="Insert Demo History" @click="insertDemoHistory()" v-if="0>1" />
      <input type="button" value="Fill Toner History" @click="fillTonerHistory()" v-if="0>1 && $root.isAdmin" />
      <input type="button" value="Reset All Printers" @click="resetAllPrintersAdmin()" v-if="10>1 && $root.isAdmin" />
      <input type="button" value="Reset Current Printers" @click="resetCurrentPrinters()" v-if="0>1 && $root.isAdmin" />
      <input type="button" value="Refresh All Printers" @click="refreshAllPrintersAdmin()" v-if="0>1" />
      <input type="button" value="Clear Pending Alerts" @click="clearPendingAlerts()" v-if="0>1" />
      <input type="button" value="Copy One Printer From History" v-if="0>1" @click="copyPrintersFromRT_HistoryToFirestore()" />
      <input type="button" value="Get Printers From History" v-if="0>1" @click="getPrintersFromRT_History()" />
      <input type="button" value="Copy One Printer From RT_Printers To Store_Printers" v-if="0>1" @click="copyPrintersFromRT_PrintersToStore_Printers()" />
      <h1 style="float: left; padding-right: 10px;">{{ $root.title}}</h1>
      <a v-if="hasData" title="Export CSV file" href="#" @click="exportCSV()" style="float: left; padding: 5px 10px;"><i class="fa fa-download" style="font-size: 20px;"></i></a>
      <h1 style="float: left; padding-right: 10px;" v-if="titleCustomerSite">({{titleCustomerSite}})</h1>
      <div v-show="!showDefault" action="#" method="get" class="sidebar-form" style="width: 200px; border-radius: 3px; float: right; margin: 0px; border: 1px solid #337ab7;">
        <div class="input-group">
          <input type="text" name="q" class="form-control" placeholder="Search..." v-model="$root.txtSearch" style="box-shadow: none;height: 27px; background-color: #fff;">
          <div class="input-group-btn">
            <div class="btn btn-flat" style="height: 28px; padding: 4px 6px; background-color: #fff;"><i class="fa fa-search"></i></div>
          </div>
        </div>
      </div>
      <div v-show="!showDefault" :class="['box-tools', $root.device.isMobile?'tabsMobile':'']" style="float: right; padding: 0px 10px;">
        <ul class="pagination pagination-sm inline" style="cursor: pointer;">
          <li v-if="!$root.device.isMobile" :class="[options.activeFilter==='All' ? 'active' : '']"><a @click="options.activeFilter='All'" style="width: 80px!important; text-align: center;">All</a></li>
          <li :class="[options.activeFilter==='Toners' ? 'active' : '']"><a @click="options.activeFilter='Toners'" style="width: 80px!important; text-align: center;">Toners</a></li>
          <li :class="[options.activeFilter==='Counters' ? 'active' : '']"><a @click="options.activeFilter='Counters'" style="width: 80px!important; text-align: center;">Counters</a></li>
          <li :class="[options.activeFilter==='Info' ? 'active' : '']"><a @click="options.activeFilter='Info'" style="width: 80px!important; text-align: center;">Info</a></li>
          <li :class="[options.activeFilter==='Deleted' ? 'active' : '']"><a @click="options.activeFilter='Deleted'" style="width: 80px!important; text-align: center;">Deleted</a></li>
          <li v-if="0>1" :class="[options.activeFilter==='TonerHistory' ? 'active' : '']"><a @click="options.activeFilter='TonerHistory'" style="width: 100px!important; text-align: center;">Toner History</a></li>
        </ul>
      </div>
    </section>
    <div class="box-body">
      <div class="table-responsive" style="width: 100%;">
        <va-box v-show="showDefault" title="Statistics" theme="box-info" :isLoading="isLoading" :isBorder="true" widgetType="">
          <div slot="content" style="min-height: 350px; height: 100%; padding: 10px;">
            <va-alert type="warning">
              <h4 slot="header">
                <i class="icon fa fa-warning"></i> Please select Customer/Site from the side menu, to view printers !
              </h4>
            </va-alert>
            <div class="col-lg-1 col-md-1">
            </div>
            <div class="col-lg-4 col-md-4">
              <p class="text-center">
                <strong>Info</strong>
              </p>
              <row>
                <va-info-box bgColor="bg-green"
                             bgIcon="ion ion-ios-printer-outline"
                             text="Total Printers"
                             :number="$root.dashData.TotalPrinters"
                             moreText="All Printers"
                             @more-click="showAllPrinters=true"></va-info-box>
              </row>
              <row>
                <va-info-box bgColor="bg-green"
                             bgIcon="ion-stats-bars"
                             text="Total Sites"
                             :number="$root.dashData.TotalSites"
                             moreText="All Sites"
                             @more-click="$root.goto('Sites')"></va-info-box>
              </row>
            </div>
            <div class="col-lg-1 col-md-1">
            </div>
            <div class="col-lg-5 col-md-5">
              <p class="text-center">
                <a href="#" @click="$root.showStatuses = !$root.showStatuses">
                  <strong style="color: #000;">Printers Status</strong>
                </a>
              </p>
              <!-- /.progress-group -->
              <div class="progress-group" @click="$root.goto('PrintersOnline')">
                <span class="progress-text">Online</span>
                <span class="progress-number"><b>{{$root.dashData.PrintersStatus?$root.dashData.PrintersStatus.TotalOnline:0}}</b>/{{$root.dashData.TotalPrinters}}</span>
                <div class="progress sm">
                  <div class="progress-bar progress-bar-green" :style="{ width: $root.calcPercent($root.dashData.PrintersStatus?$root.dashData.PrintersStatus.TotalOnline:0, $root.dashData.TotalPrinters) }"></div>
                </div>
              </div>
              <!-- /.progress-group -->
              <div class="progress-group" @click="$root.goto('PrintersOffline')">
                <span class="progress-text">Offline</span>
                <span class="progress-number"><b>{{$root.dashData.PrintersStatus?$root.dashData.PrintersStatus.TotalOffline:0}}</b>/{{$root.dashData.TotalPrinters}}</span>
                <div class="progress sm">
                  <div class="progress-bar progress-bar-red" :style="{ width: $root.calcPercent($root.dashData.PrintersStatus?$root.dashData.PrintersStatus.TotalOffline:0, $root.dashData.TotalPrinters) }"></div>
                </div>
              </div>
              <div class="progress-group" @click="$root.goto('PrintersOutOfPaper')">
                <span class="progress-text">Out of Paper</span>
                <span class="progress-number"><b>{{$root.dashData.PrintersStatus?$root.dashData.PrintersStatus.TotalOutPaper:0}}</b>/{{$root.dashData.TotalPrinters}}</span>
                <div class="progress sm">
                  <div class="progress-bar progress-bar-aqua" :style="{ width: $root.calcPercent($root.dashData.PrintersStatus?$root.dashData.PrintersStatus.TotalOutPaper:0, $root.dashData.TotalPrinters) }"></div>
                </div>
              </div>
              <div class="progress-group" @click="$root.goto('PrintersLowToner')">
                <span class="progress-text">Low Toner</span>
                <span class="progress-number"><b>{{$root.dashData.PrintersStatus?$root.dashData.PrintersStatus.TotalOutToner:0}}</b>/{{$root.dashData.TotalPrinters}}</span>
                <div class="progress sm">
                  <div class="progress-bar progress-bar-aqua" :style="{ width: $root.dashData.PrintersStatusPercent.TotalOutToner }"></div>
                </div>
              </div>
              <!-- /.progress-group -->
              <div class="progress-group" @click="$root.goto('PrintersErrors')">
                <span class="progress-text">Errors</span>
                <span class="progress-number"><b>{{$root.dashData.PrintersStatus?$root.dashData.PrintersStatus.TotalError:0}}</b>/{{$root.dashData.TotalPrinters}}</span>
                <div class="progress sm">
                  <div class="progress-bar progress-bar-yellow" :style="{ width: $root.calcPercent($root.dashData.PrintersStatus?$root.dashData.PrintersStatus.TotalError:0, $root.dashData.TotalPrinters) }"></div>
                </div>
              </div>
              <!-- /.progress-group -->
            </div>
          </div>
        </va-box>
        <VueTable v-show="!showDefault && !showDeleted"
                  :isLoading="isLoading"
                  :columns="columns"
                  :info="infoIcons"
                  :rows="filteredItems"
                  :pageSize="pageSize"
                  @rowClick="rowClick"
                  @headerClick="headerClick"
                  :options="options"></VueTable>

        <VueTable v-show="!showDefault && showDeleted"
                  :isLoading="isLoading"
                  :columns="columnsDeleted"
                  :info="infoIcons"
                  :rows="filteredDeletedItems"
                  :pageSize="pageSize"
                  @rowClick="rowClick"
                  @headerClick="headerClick"
                  :options="options"></VueTable>

      </div>
      <!-- /.table-responsive -->
    </div>
    <AddPrinter></AddPrinter>
    <!--<va-modal></va-modal>-->
  </div>
</template>
<script>
  import VueTable from '../components/Table/DataTable.vue'
  import AddPrinter from '../components/AddPrinter'
  // import Modal from '../components/Modal'
  import VABox from '../widgets/VABox.vue'
  import VASmallBox from '../widgets/VASmallBox.vue'
  import VAInfoBox from '../widgets/VAInfoBox.vue'
  import VAAlert from '../components/VAAlert.vue'
  import { RunTest } from '../plugins/TestPrinters.js'

  // import FilteredPrintersHistory from '../plugins/09FilteredPrintersHistory.json'

  import { db, dbStore, dbListener } from '../firebase'
  export default {
    name: 'printers',
    components: {
      VueTable,
      'va-box': VABox,
      'va-info-box': VAInfoBox,
      'va-small-box': VASmallBox,
      // 'va-modal': Modal,
      'va-alert': VAAlert,
      AddPrinter
    },
    data () {
      return {
        IsDbMoved: false,
        resetTimer: null,
        timerCountDown: (1000 * 60 * 1), // 1 minute
        options: { showDefault: false, activeFilter: 'Toners' },
        pageSize: 10,
        printers: [],
        printersDeleted: [],
        refreshPrinters: [],
        activeFilter: 'Toners',
        titleCustomerSite: '',
        showAllPrinters: false,
        isLoading: false,
        hasFilter: false,
        infoIcons: [
          { icon: 'fa fa-star text-yellow', label: 'New Printer' },
          { icon: 'fa fa-circle text-green', label: 'Online' },
          { icon: 'fa fa-circle text-red', label: 'Offline' },
          { icon: 'fa fa-circle text-orange', label: 'Other' },
          { icon: 'fa fa-circle text-gray', label: 'Deleted' }
        ],
        columns: [
          { fieldName: 'Status', label: '', isSortable: false, isHidden: false, isStatus: true },
          // { fieldName: 'Status', label: 'Status', isSortable: true, isHidden: false, length: 50 },
          { fieldName: 'Logged', sortFieldName: 'LoggedInt', label: 'Date', isSortable: true, isHidden: false, length: 20 },
          { fieldName: 'MacAddress', label: 'MAC Address', isSortable: true, isHidden: false },
          { fieldName: 'PrinterSerial', label: 'Serial', isSortable: true, isHidden: false, isLink: true, route: 'Printer', param: 'MacAddress' },
          { fieldName: 'IsUSB', label: '', isSortable: false, isHidden: false, isStatus: true },
          // { fieldName: 'ModelName', label: 'Model', isSortable: true, isHidden: false, length: 14 },
          { fieldName: 'ModelName', label: 'Model', isSortable: true, isHidden: false, length: 50 },
          { fieldName: 'IPAddress', label: 'IP Address', isSortable: true, isHidden: false, filterKey: 'Info' },
          // { fieldName: 'IPAddress', label: 'IP Address', isSortable: true, isHidden: false, filterKey: 'Deleted' },
          { fieldName: 'PageCount', label: 'Pages', isSortable: true, isHidden: false, filterKey: 'Counters' },
          { fieldName: 'HostName', label: 'Host', isSortable: true, isHidden: false, filterKey: 'Info', length: 12 },
          { fieldName: 'Location', label: 'Location', isSortable: true, isHidden: false, filterKey: 'Info', length: 30 },
          { fieldName: 'Dealer', label: 'Dealer', isSortable: true, isHidden: false, filterKey: 'All', length: 10 },
          { fieldName: 'Customer', label: 'Customer', isSortable: true, isHidden: false, filterKey: 'Info', length: 10 },
          { fieldName: 'Site', label: 'Site', isSortable: true, isHidden: false, filterKey: 'Info', length: 10 },
          { fieldName: 'Customer', label: 'Customer', isSortable: true, isHidden: false, filterKey: 'Deleted', length: 10 },
          { fieldName: 'Site', label: 'Site', isSortable: true, isHidden: false, filterKey: 'Deleted', length: 10 },
          { fieldName: 'DeviceCode', label: 'Code', isSortable: true, isHidden: false, isEditable: true, filterKey: 'Info', length: 20 },
          { fieldName: 'ErrorString', label: 'Error', isSortable: true, isHidden: false, filterKey: 'Info', length: 16 },
          // { fieldName: 'Status', label: 'Status', isSortable: true, isHidden: false, filterKey: 'Info', length: 16 },
          { fieldName: 'A4Black', label: 'A4Black', isSortable: true, isHidden: false, filterKey: 'Counters', width: '80px' },
          { fieldName: 'A4Color', label: 'A4Color', isSortable: true, isHidden: false, filterKey: 'Counters', width: '80px' },
          { fieldName: 'A3Black', label: 'A3Black', isSortable: true, isHidden: false, filterKey: 'Counters', width: '80px' },
          { fieldName: 'A3Color', label: 'A3Color', isSortable: true, isHidden: false, filterKey: 'Counters', width: '80px' },
          // { fieldName: 'Copy', label: 'Copy', isSortable: true, isHidden: false, filterKey: 'Counters', width: '80px' },
          // { fieldName: 'Scan', label: 'Scan', isSortable: true, isHidden: false, filterKey: 'Counters', width: '80px' },
          // { fieldName: 'Duplex', label: 'Duplex', isSortable: true, isHidden: false, filterKey: 'Counters', width: '80px' },
          // { fieldName: 'Fax', label: 'Fax', isSortable: true, isHidden: false, filterKey: 'Counters', width: '80px' },
          { fieldName: 'BlackTonerLeft', label: 'Black', isSortable: true, isHidden: false, isProgress: true, filterKey: 'Toners' },
          { fieldName: 'CyanTonerLeft', label: 'Cyan', isSortable: true, isHidden: false, isProgress: true, filterKey: 'Toners' },
          { fieldName: 'MagentaTonerLeft', label: 'Magenta', isSortable: true, isHidden: false, isProgress: true, filterKey: 'Toners' },
          { fieldName: 'YellowTonerLeft', label: 'Yellow', isSortable: true, isHidden: false, isProgress: true, filterKey: 'Toners' },
          {
            fieldName: 'VueBottons',
            label: 'Refresh',
            funcName: 'refreshAllPrinters',
            iconClass: 'fa fa-refresh',
            isBotton: true,
            isSortable: false,
            isHidden: false,
            bottons: [
              { name: 'RefreshPrinter', fieldName: 'IsRefresh', label: 'Refresh Printer Data', iconClass: 'fa fa-refresh', color: '#3c8dbc' },
              { name: 'InfoPrinter', label: 'Printer Info', iconClass: 'fa fa-info-circle', color: '#3c8dbc', isLink: true, route: 'Printer', param: 'MacAddress' },
              { name: 'HistoryPrinter', label: 'Printer History', iconClass: 'fa fa-history', color: '#008000', isLink: true, route: 'PrinterHistory', param: 'MacAddress' },
              { name: 'Delete', label: 'Delete', iconClass: 'fa fa-trash-o', color: 'red', isHidden: true }
            ]
          }
        ],
        columnsDeleted: [
          { fieldName: 'Status', label: '', isSortable: false, isHidden: false, isStatus: true },
          { fieldName: 'MacAddress', label: 'MAC Address', isSortable: true, isHidden: false },
          { fieldName: 'PrinterSerial', label: 'Serial', isSortable: true, isHidden: false, isLink: true, route: 'Printer', param: 'MacAddress' },
          { fieldName: 'IsUSB', label: '', isSortable: false, isHidden: false, isStatus: true },
          // { fieldName: 'ModelName', label: 'Model', isSortable: true, isHidden: false, length: 14 },
          { fieldName: 'ModelName', label: 'Model', isSortable: true, isHidden: false, length: 50 },
          { fieldName: 'IPAddress', label: 'IP Address', isSortable: true, isHidden: false },
          { fieldName: 'Customer', label: 'Customer', isSortable: true, isHidden: false, length: 10 },
          { fieldName: 'Site', label: 'Site', isSortable: true, isHidden: false, length: 10 },
          {
            fieldName: 'VueBottons',
            isSortable: false,
            isHidden: false,
            bottons: [
              { name: 'Restore', label: 'Restore', iconClass: 'fa fa-recycle', color: '#FF851B', isHidden: true },
              { name: 'InfoPrinter', label: 'Printer Info', iconClass: 'fa fa-info-circle', color: '#3c8dbc', isLink: true, route: 'Printer', param: 'MacAddress' },
              { name: 'HistoryPrinter', label: 'Printer History', iconClass: 'fa fa-history', color: '#008000', isLink: true, route: 'PrinterHistory', param: 'MacAddress' }
            ]
          }
        ]
      }
    },
    created () {
      console.log('Printers created...')
      this.$root.title = 'Printers'
      // delete this.columns[this.columns.length - 1].bottons[2]
      // alert(this.$root.user.UserType + ' >> ' + this.columns[this.columns.length - 1].bottons[2].name)
      if (this.$root.isCustomer) {
        this.showAllPrinters = true
        let index = this.columns.findIndex(c => c.fieldName === 'VueBottons')
        if (index > -1) {
          if (this.columns[index]) {
            let indexDel = this.columns[index].bottons.findIndex(item => item.name === 'Delete')
            if (indexDel > -1) {
              if (this.columns[index].bottons[indexDel]) {
                this.columns[index].bottons.splice(indexDel, 1)
              }
            }
          }
        }
      }
      if (this.$root.userHistory) {
        if (this.$root.userHistory.selectedTab) {
          this.activeFilter = this.$root.userHistory.selectedTab
        }
        this.$root.userHistory.selectedCustomer = this.$route.params.customerKey
        this.$root.userHistory.selectedSite = this.$route.params.siteKey
        this.$root.setUserHistory()
      }
    },
    mounted () {
      console.log('Printers mounted...')
      this.reloadPrinters()
    },
    updated () {
      console.log('Printers updated...')
      // this.siteKey = this.$route.params.siteKey
      // this.customerKey = this.$route.params.customerKey
    },
    computed: {
      showDeleted () {
        return this.options.activeFilter === 'Deleted'
      },
      customerSiteKey () {
        return this.$route.params.customerKey + '_' + this.$route.params.siteKey
      },
      showDefault () {
        this.options.showDefault = (this.customerSiteKey === 'All_All') && !this.showAllPrinters
        return this.options.showDefault
      },
      hasData () {
        return this.filteredItems !== null && this.filteredItems !== undefined && this.filteredItems.length > 0
      },
      filteredItems () {
        const vm = this
        let result = []
        if (vm.$root.txtSearch.length > 0) {
          let txtSearch = vm.$root.txtSearch.trim().toLowerCase()
          try {
            result = vm.printers.filter(function (row) {
              return Object.keys(row).some(function (key) {
                if (String(row[key]).trim().toLowerCase().indexOf(txtSearch) > -1) {
                  return row
                }
              })
            })
          } catch (e) {
            console.log(e)
            result = []
          }
        } else {
          result = vm.printers
        }
        return result
      },
      filteredDeletedItems () {
        const vm = this
        let result = []
        if (vm.$root.txtSearch.length > 0) {
          let txtSearch = vm.$root.txtSearch.trim().toLowerCase()
          try {
            result = vm.printersDeleted.filter(function (row) {
              return Object.keys(row).some(function (key) {
                if (String(row[key]).trim().toLowerCase().indexOf(txtSearch) > -1) {
                  return row
                }
              })
            })
          } catch (e) {
            console.log(e)
            result = []
          }
        } else {
          result = vm.printersDeleted
        }
        return result
      },
      paramsStatusFilter () {
        return this.$route.params.statusFilter
      }
    },
    watch: {
      paramsStatusFilter (val) {
        console.log('paramsStatusFilter = ' + val)
        this.reloadPrinters()
      },
      activeFilter (val) {
        if (val !== 'All') {
          this.$root.userHistory.selectedTab = val
          this.$root.setUserHistory()
        }
      },
      customerSiteKey (val) {
        this.showAllPrinters = false
        if (this.$root.userHistory) {
          this.$root.userHistory.selectedCustomer = this.$route.params.customerKey
          this.$root.userHistory.selectedSite = this.$route.params.siteKey
          this.$root.setUserHistory()
        }
        this.reloadPrinters()
      },
      siteKey (val) {
        // if (val && val !== 'All') {

        // }

        // this.$root.filter.siteKey = val
        // this.$root.filter.siteKey = this.siteKey
        // this.$root.filter.customerKey = this.customerKey
        this.reloadPrinters()
      },
      showAllPrinters (val) {
        if (val) {
          if (this.$root.isAdmin) {
            this.loadAllPrinters()
          } else if (this.$root.isDealer) {
            this.loadDealerPrinters()
          } else if (this.$root.isCustomer) {
            this.loadCustomerPrinters()
          }
        }
      },
      '$root.filter.dealerKey' (val) {
        if (val) {
          console.log('$root.filter.dealerKey =>>> ' + this.$root.filter.dealerKey)
          this.reloadPrinters()
        }
      }
    },
    methods: {
      insertDemoHistory () {
        let vm = this
        var len = FilteredPrintersHistory.length
        // alert(len)
        console.log('FilteredPrintersHistory Length = ' + len)
        // FilteredPrintersHistory
        // /PrintersHistory/Dealers/xeAsdSOOiqYM5sOZSh2zI6KHwGw1/Customers/-MPj-exDvnr_kpl9vIEF/Printers
        // /PrintersHistory/xeAsdSOOiqYM5sOZSh2zI6KHwGw1/Customers/-MPj-exDvnr_kpl9vIEF/Years
        // /PrintersHistory/Dealers/xeAsdSOOiqYM5sOZSh2zI6KHwGw1/Customers/-MPj-exDvnr_kpl9vIEF/2021/01/00-17-C8-48-4B-BB_202101080622
        vm.$root.filter.dealerKey = 'xeAsdSOOiqYM5sOZSh2zI6KHwGw1'
        vm.$route.params.customerKey = '-MPj-exDvnr_kpl9vIEF'
        vm.$route.params.siteKey = '-MPj-g41vWGkrdACxuqb'
        // path += 'Printers/'
        let counter = 0
        FilteredPrintersHistory.forEach(function (printer) {
          let path = ''
          path += 'PrintersHistory/'
          path += 'Dealers/'
          path += printer.DealerKey + '/'
          path += 'Customers/'
          path += printer.CustomerKey + '/'
          // 2021-01-05 19:59:32
          path += vm.$moment(printer.Logged, 'YYYY-MM-DD HH:mm:ss').format('YYYY') + '/'
          path += vm.$moment(printer.Logged, 'YYYY-MM-DD HH:mm:ss').format('MM') + '/'
          // console.log(JSON.stringify(printer))
          // console.log(JSON.stringify(path))
          // alert(path)
          let docPath = printer.MacAddress + '_' + printer.LoggedInt
          dbStore.collection(path).doc(docPath).set(printer).then(function (result) {
            counter++
            console.log(len + ' : ' + counter + ' Success : ' + path)
          }).catch(function (err) {
            console.log(len + ' : ' + counter + ' Error : ' + err)
          })
        })
      },
      async getDemoHistory () {
        let vm = this
        let MacAddress = '80-CE-62-5C-B3-CF'
        // Push Printer to path: PrintersHistory/Dealers/UbMCpyGScbhRkNzuEvdf8uUqMgi2/Customers/-MEwMc1gMl5FXcs4G0jh/2021/01/80-CE-62-5C-B3-CF_202101251310
        let datePath = '2021/01/'
        let path = ''
        path += 'PrintersHistory/'
        path += 'Dealers/'
        path += 'UbMCpyGScbhRkNzuEvdf8uUqMgi2/'
        path += 'Customers/'
        path += '-MEwMc1gMl5FXcs4G0jh/'
        path += datePath //  ==> YYYY/MM/
        // let docPath = printer.MacAddress + '_' + firstDayFirstHour
        let printersRef = dbStore.collection(path).orderBy('LoggedInt', 'asc').where('MacAddress', '==', MacAddress).limit(1)

        return printersRef.get().then(function (snapPrinters) {
          console.log('snapPrinters.size = ' + snapPrinters.size)
          if (snapPrinters.size > 0) {
            let historyPrinter = snapPrinters.docs[0].data()
            console.log('Found in History IsExistInFirstDayOfMonth() ::::')
            console.log(JSON.stringify(historyPrinter))
            let daysDiff = Number(vm.$moment(historyPrinter.Logged, 'YYYY-MM-DD HH:mm:ss').format('DD')) - 1
            console.log('Days diff = ' + daysDiff)
          } else {
          }
        }).catch((err) => {
          console.log('Error: ' + err)
        })
        /*
        // /PrintersHistory/xeAsdSOOiqYM5sOZSh2zI6KHwGw1/Customers/-MPj-exDvnr_kpl9vIEF/Years
        vm.$root.filter.dealerKey = 'xeAsdSOOiqYM5sOZSh2zI6KHwGw1'
        vm.$route.params.customerKey = '-MPj-exDvnr_kpl9vIEF'
        vm.$route.params.siteKey = '-MPj-g41vWGkrdACxuqb'
        // /PrintersHistory/Dealers/y2TVVKErZTdDymWJgs1IlZ9KeGL2/Customers/-M8eKU0pVVW5oGK4k63A/2020/12
        let path = ''
        path += 'PrintersHistory/'
        path += 'Dealers/'
        path += 'y2TVVKErZTdDymWJgs1IlZ9KeGL2/'
        path += 'Customers/'
        path += '-M8eKU0pVVW5oGK4k63A/'
        // 2021-01-05 19:59:32
        path += '2020/'
        path += '12/'
        // console.log(JSON.stringify(printer))
        // console.log(JSON.stringify(path))
        // alert(path)
        const firstDay = '20201201'
        const MacAddress = '00-17-C8-4B-73-5E'
        let searchDocId = MacAddress + '_' + firstDay
        console.log(searchDocId)
        console.log('Before : loadSitePrinters ')
        // vm.loadSitePrinters()
        // desc (z to a)
        // acs (a to z)
        let printersRef = dbStore.collection(path).orderBy('LoggedInt', 'asc').where('MacAddress', '==', MacAddress).limit(1)
        const snapPrinters = await printersRef.get()
        console.log('empty = ' + snapPrinters.empty)
        console.log('found = ' + snapPrinters.size)
        console.log(snapPrinters)
        if (snapPrinters.size > 0) {
          console.log(snapPrinters.docs[0].data())
        }
        snapPrinters.forEach(function (prn) {
          console.log(prn.id, ' => ', JSON.stringify(prn.data()))
        })
        dbStore.collection(path).orderBy('LoggedInt', 'asc').where('MacAddress', '==', MacAddress).limit(1).get().then(function (querySnapshot) {
          querySnapshot.forEach(function (prn) {
            console.log(prn.id, ' => ', JSON.stringify(prn.data()))
            let daysDiff = Number(vm.$moment(prn.data().Logged, 'YYYY-MM-DD HH:mm:ss').format('DD')) - 1
            console.log('Days diff = ' + daysDiff)
          })
        })
        console.log('After : loadSitePrinters ')
        */
      },
      clearPendingAlerts () {
        let vm = this
        db.ref('PendingAlerts').orderByKey().limitToFirst(1000).once('value', (snapData) => {
          const data = snapData.val()
          if (data) {
            const mKeys = Object.keys(data)
            let found = mKeys.length
            console.log('found = ' + found)
            for (let i = 0; i < found; i++) {
              let mKey = mKeys[i]
              db.ref('PendingAlerts/' + mKey).remove()
              if ((i + 1) === found) {
                vm.clearPendingAlerts()
              }
            }
          }
        })
      },
      getPrintersFromRT_History () {
        console.log(new Date().getTime() + ' >>> ' + 'getPrintersFromHistory() STARTED .... ')
        // let vm = this
        let last = 5000
        let printers = {}
        db.ref('History').orderByKey().limitToLast(last).once('value', (snapPrintersHistory) => {
          const data = snapPrintersHistory.val()
          if (data) {
            console.log(new Date().getTime() + ' >>> ' + 'DATA :::')
            // console.log(data)
            const pritnerKeys = Object.keys(data)
            let found = pritnerKeys.length
            console.log(new Date().getTime() + ' >>> ' + 'found = ' + found)
            for (let i = 0; i < found; i++) {
              let pKey = pritnerKeys[i]
              /*
              let printer = {
                MacAddress: data[pKey].MacAddress,
                Logged: data[pKey].Logged,
                DealerKey: data[pKey].DealerKey,
                CustomerKey: data[pKey].CustomerKey,
                SiteKey: data[pKey].SiteKey
              }
              */
              if (printers[data[pKey].MacAddress]) {
                console.log(new Date().getTime() + ' >>> ' + 'Printer [' + data[pKey].MacAddress + '] EXIST !!!! + Status = ' + data[pKey].Status + ' DealerKey = ' + data[pKey].DealerKey)
                console.log(new Date().getTime() + ' >>> Logged: ' + printers[data[pKey].MacAddress].Logged + ' Logged Again: ' + data[pKey].Logged)
              } else {
                printers[data[pKey].MacAddress] = {
                  Logged: data[pKey].Logged,
                  DealerKey: data[pKey].DealerKey,
                  CustomerKey: data[pKey].CustomerKey,
                  SiteKey: data[pKey].SiteKey
                }
              }
              // printers.push(data[pKey].printer)
            }
            console.log(JSON.stringify(printers))
            console.log(new Date().getTime() + ' >>> ' + 'Data is ready')
          } else {
            console.error('No Data Found!!!')
          }
        })
      },
      copyPrintersFromRT_PrintersToStore_Printers () {
        console.log('copyPrintersFromRT_PrintersToStore_Printers() STARTED .... ')
        // let vm = this
        // let first = 100
        /*
        db.ref('Printers').orderByKey().once('value', (snapPrinters) => {
          const data = snapPrinters.val()
          if (data) {
            // console.log(data)
            const pritnerKeys = Object.keys(data)
            let found = pritnerKeys.length
            console.log('found = ' + found)
            for (let i = 0; i < found; i++) {
              let pKey = pritnerKeys[i]
              let printer = data[pKey]
              dbStore.collection('Printers').doc(pKey).set(printer).then(function (res) {
                console.log(res)
              })
            }
          }
        })
        */
      },
      copyPrintersFromRT_HistoryToFirestore () {
        /*
        let printersRef = dbStore.collection('Printers')
        printersRef.get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            console.log(doc.id, ' => ', doc.data())
          })
        }).catch(function (err) {
          console.log(err)
        })
        */
        /*
        dbStore.collection('/Printers/00-21-B7-13-BF-A2/Logs/2019/01/').get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            console.log(doc.id, ' => ', doc.data())
          })
        })
        */
        console.log('copyPrintersFromHistoryToFirestore() STARTED .... ')
        let vm = this
        let first = 1000
        // db.ref('History').orderByChild('LoggedInt').startAt(0).endAt(202002302359).limitToFirst(first).once('value', (snapPrintersHistory) => {
        // db.ref('History').orderByChild('LoggedInt').limitToFirst(first).once('value', (snapPrintersHistory) => {
        db.ref('History').orderByKey().limitToFirst(first).once('value', (snapPrintersHistory) => {
        // db.ref('History').orderByKey().limitToLast(first).once('value', (snapPrintersHistory) => {
          const data = snapPrintersHistory.val()
          if (data) {
            // console.log(data)
            const pritnerKeys = Object.keys(data)
            let found = pritnerKeys.length
            console.log('found = ' + found)
            for (let i = 0; i < found; i++) {
              let pKey = pritnerKeys[i]
              let printer = data[pKey]
              // printer['.key'] = pKey
              // console.log(JSON.stringify(printer))
              // /Printers/00-21-B7-13-BF-A2/Logs/2019
              // printersRef = dbStore.collection('Printers').doc(printer.MacAddress)
              // printersRef.collection("Logs").add()
              // console.log(printer.LoggedInt)
              // 2019042413
              // 201904241350
              // Logged
              // 2020-12-22 21:21:38
              // 2019042413
              // if (printer.LoggedInt > 20200000) {
              if (printer.LoggedInt > 0) {
                let strLoggedInt = printer.LoggedInt + ''
                let year = strLoggedInt.substring(0, 4)
                let month = strLoggedInt.substring(4, 6)
                let day = strLoggedInt.substring(6, 8)
                let hour = strLoggedInt.substring(8, 10)
                let minute = strLoggedInt.substring(10, 12)
                if (Number(year) >= 2019 && Number(year) <= 2050) {
                  if (Number(month) >= 1 && Number(month) <= 12) {
                    if (Number(day) >= 1 && Number(day) <= 31) {
                      console.log((i + 1) + ' >>> DATE :::: ' + year + ' >> ' + month + ' >> ' + day + ' >> ' + hour + ' >> ' + minute + ' ::: (' + printer.LoggedInt + ')')
                      if (printer.MacAddress && printer.MacAddress !== undefined && printer.MacAddress !== 'undefined') {
                        // && Number(month) === 1
                        //  || (Number(year) === 2020 && Number(month) === 1)
                        if ((Number(year) >= 2019)) { // First we move printers of the year 2019
                          let datePath = year + '/' + month + '/' + day
                          let path = 'PrintersHistory/' + datePath + '/' + printer.MacAddress
                          dbStore.collection(path).doc(hour + '00').set(printer).then(function (result) {
                            console.log((i + 1) + ' >>> Success(' + path + ' : ' + hour + ') ' + 'pKey=' + pKey)
                            db.ref('History/' + pKey).remove()
                            // console.log(pKey + ' >>> Removed(' + printer.MacAddress + ')')
                            if ((i + 1) === found) {
                              vm.copyPrintersFromHistoryToFirestore()
                            }
                          })
                        } else {
                          console.log('(Number(year) === 2019) >>> ' + (Number(year) === 2019))
                          console.log('(Number(year) === 2020) >>> ' + (Number(year) === 2020))
                          console.log('(Number(month) === 1) >>> ' + (Number(month) === 1))
                        }
                      } else {
                        console.error('WRONGE MacAddress :::: ' + printer.MacAddress + ' >> Key = ' + pKey)
                        db.ref('History/' + pKey).remove()
                        if ((i + 1) === found) {
                          vm.copyPrintersFromHistoryToFirestore()
                        }
                      }
                    } else {
                      console.error('WRONGE DATE :::: ' + year + ' >> ' + month + ' >> ' + day)
                      db.ref('History/' + pKey).remove()
                      if ((i + 1) === found) {
                        vm.copyPrintersFromHistoryToFirestore()
                      }
                    }
                  } else {
                    console.error('WRONGE DATE :::: ' + year + ' >> ' + month + ' >> ' + day)
                    db.ref('History/' + pKey).remove()
                    if ((i + 1) === found) {
                      vm.copyPrintersFromHistoryToFirestore()
                    }
                  }
                } else {
                  console.error('WRONGE DATE :::: ' + year + ' >> ' + month + ' >> ' + day)
                  db.ref('History/' + pKey).remove()
                  if ((i + 1) === found) {
                    vm.copyPrintersFromHistoryToFirestore()
                  }
                }
              } else {
                console.error('printer.LoggedInt < 20200000' + ' (' + printer.LoggedInt > 20200000 + ')')
              }
            }
          } else {
            console.error('No Data Found!!!')
          }
        })
      },
      headerClick (btn) {
        switch (btn) {
          case 'refreshAllPrinters': this.refreshAllPrinters(); break
          default: break
        }
      },
      refreshAllPrinters () {
        console.log('Printers refreshAllPrinters()...')
        let vm = this
        let refreshSites = {}
        if (vm.filteredItems && vm.filteredItems.length > 0) {
          vm.resetTimer = setInterval(vm.resetCurrentPrinters, vm.timerCountDown)
          for (let i = 0; i < vm.filteredItems.length; i++) {
          // this.refreshPrinter(vm.filteredItems[i])
            let item = vm.filteredItems[i]
          // console.log(item)
            refreshSites[item.SiteKey] = { 'RefreshAll': true }
            if (item.IsRefresh === 'Ready') {
              item.IsRefresh = 'Refresh'
              // console.log(i + ':: Printers refresh Printer(' + item.MacAddress + ')...')
              db.ref('Printers/' + item.MacAddress + '/IsRefresh').set('Refresh')
              let starCountRef = db.ref('Printers/' + item.MacAddress)
              let listener = starCountRef.on('value', function (snapshot) {
                let printer = snapshot.val()
                // console.log(printer)
                if (printer.IsRefresh === 'Ready') {
                  Object.keys(printer).map(key => {
                    item[key] = printer[key]
                  })
                  var today = vm.$moment()
                  var logDay = vm.$moment(printer.Logged, 'YYYY-MM-DD HH:mm:ss')
                  let diffDays = today.diff(logDay, 'days')
                  // console.log('diffDays = ' + diffDays)
                  item.IsNew = (diffDays <= 14)
                  let dealer = vm.$root.dealers.find(c => c.value === printer.DealerKey)
                  if (dealer) {
                    item['Dealer'] = dealer.title
                  }
                  let cust = vm.$root.customers.find(c => c.value === printer.CustomerKey)
                  if (cust) {
                    item['Customer'] = cust.title
                  }
                  let site = vm.$root.sites.find(c => c.value === printer.SiteKey)
                  if (site) {
                    item['Site'] = site.title
                  }
                  item.PageCount = parseInt(printer.PageCount, 10)
                  item.A4Black = parseInt(printer.A4Black, 10)
                  item.A4Color = parseInt(printer.A4Color, 10)
                  item.A3Black = parseInt(printer.A3Black, 10)
                  item.A3Color = parseInt(printer.A3Color, 10)
                  item.BlackTonerLeft = vm.parseTonerLeft(printer.BlackTonerLeft, 10)
                  item.CyanTonerLeft = vm.parseTonerLeft(printer.CyanTonerLeft, 10)
                  item.MagentaTonerLeft = vm.parseTonerLeft(printer.MagentaTonerLeft, 10)
                  item.YellowTonerLeft = vm.parseTonerLeft(printer.YellowTonerLeft, 10)

                  starCountRef.off('value', listener)
                  // setTimeout(vm.resetRefreshPrinter(vm, item), 5000)
                } else {
                  item.IsRefresh = printer.IsRefresh
                }
              })
            }
          }
        }
        let sitesKeys = Object.keys(refreshSites)
        for (let k = 0; k < sitesKeys.length; k++) {
          let siteKey = sitesKeys[k]
          refreshSites[key] = { 'RefreshAll': true }
          dbListener.ref('RefreshPrinter/' + siteKey + '/RefreshAll').set(true)
        }
        /*
        db.ref('Printers/').orderByChild('SiteKey').equalTo('-MRtZsH3EHG5cFnx2ttl').once('value', (snapPrinters) => {
          snapPrinters.forEach(function (printer) {
            // printer.ref.update({ IsRefresh: 'Progress' })
            // printer.ref.update({ IsRefresh: 'Ready' })
            printer.ref.update({ IsRefresh: 'Refresh' })
          })
        })
        */
        // setTimeout(vm.resetCurrentPrinters(), 10000)
      },
      resetRefreshPrinter (vm, item) {
        console.log('resetRefreshPrinter(' + item.MacAddress + ') ... ')
        item.IsRefresh = 'Ready'
        db.ref('Printers/' + item.MacAddress + '/IsRefresh').set('Ready')
      },
      resetCurrentPrinters () {
        console.log('Reset Current Printers ')
        let vm = this
        clearInterval(vm.resetTimer)
        vm.resetTimer = null
        if (vm.filteredItems && vm.filteredItems.length > 0) {
          for (let i = 0; i < vm.filteredItems.length; i++) {
            let item = vm.filteredItems[i]
            if (item.IsRefresh !== 'Ready') {
              // console.log(i + ':: Reset Printer(' + item.MacAddress + ')...')
              item.IsRefresh = 'Ready'
              db.ref('Printers/' + item.MacAddress + '/IsRefresh').set('Ready')
            }
          }
        }
      },
      refreshSite (item) {
        console.log(item)
        let vm = this
        if (item.IsRefresh === 'Ready') {
          item.IsRefresh = 'Refresh'
          db.ref('Printers/' + item.MacAddress + '/IsRefresh').set('Refresh')
          dbListener.ref('RefreshPrinter/' + item.SiteKey + '/' + item.MacAddress).set(true)
        }
        // vm.$root.refreshPrintersList.push({ MAC: item.MacAddress, Time: vm.$moment().format('YYYY-MM-DD HH:mm:ss') })
        if (vm.$root.timer === null) {
          // vm.$root.timer = setInterval(vm.$root.resetRefreshPrinters, (1000 * 60 * 1)) // 10 sec
        }
      },
      exportCSV () {
        let vm = this
        let csv = 'Printers ' + '\n'
        let headers = []
        //  columns
        console.log(vm.columns.length)
        for (let i = 0; i < vm.columns.length; i++) {
          headers.push(vm.columns[i].label ? vm.columns[i].label : vm.columns[i].fieldName)
        }
        csv += headers.join(',')
        csv += '\n'
        console.log(csv)
        console.log(vm.filteredItems.length)
        vm.filteredItems.forEach(function (rowObj) {
          let row = []
          for (let i = 0; i < vm.columns.length; i++) {
            let item = rowObj[vm.columns[i].fieldName]
            if (item) {
              try {
                item = item.toString()
                if (item.indexOf(',') > -1) {
                  item = item.replace(',', '.')
                }
              } catch (e) {
                console.log('Error: ' + item + ' msg: ' + e.message)
              }
              row.push(item)
            } else {
              row.push(' ')
            }
          }
          csv += row.join(',')
          csv += '\n'
        })
        var BOM = '\uFEFF'
        csv = BOM + csv
        console.log(csv)
        const encodedURI = encodeURI(csv)
        const fixedEncodedURI = encodedURI.replaceAll('#', '%23')
        var hiddenElement = document.createElement('a')
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + fixedEncodedURI
        // hiddenElement.href = 'data:text/csv;charset=utf-8,' + csv
        hiddenElement.target = '_blank'
        hiddenElement.download = 'Printers ' + vm.$moment().format('YYYY-MM-DD') + '.csv'
        hiddenElement.click()
      },
      rowClick (btn, item) {
        switch (btn) {
          case 'RefreshPrinter': this.refreshPrinter(item); break
          case 'InfoPrinter': this.info(item); break
          case 'HistoryPrinter': this.history(item); break
          case 'Delete': this.confirmDelete(item); break
          case 'DeviceCode': this.editCode(item); break
          case 'Restore': this.restorePrinter(item); break
          default: break
        }
      },
      testPrinters () {
        let vm = this
        try {
          RunTest(vm, vm.printers, db)
        } catch (e) {
          console.log(e)
          console.log({ Code: 900, Message: 'Error: ' + e.Message })
        }
      },
      updatePrinter (printer) {

      },
      refreshPrinter (item) {
        console.log(item)
        let vm = this
        if (item.IsRefresh === 'Ready') {
          item.IsRefresh = 'Refresh'
          db.ref('Printers/' + item.MacAddress + '/IsRefresh').set('Refresh')
          dbListener.ref('RefreshPrinter/' + item.SiteKey + '/' + item.MacAddress).set(true)
          var starCountRef = db.ref('Printers/' + item.MacAddress)
          let listener = starCountRef.on('value', function (snapshot) {
            var printer = snapshot.val()
            console.log(printer)
            Object.keys(printer).map(key => {
              item[key] = printer[key]
            })
            var today = vm.$moment()
            var logDay = vm.$moment(printer.Logged, 'YYYY-MM-DD HH:mm:ss')
            let diffDays = today.diff(logDay, 'days')
            // console.log('diffDays = ' + diffDays)
            item.IsNew = (diffDays <= 14)
            let dealer = vm.$root.dealers.find(c => c.value === printer.DealerKey)
            if (dealer) {
              item['Dealer'] = dealer.title
            }
            let cust = vm.$root.customers.find(c => c.value === printer.CustomerKey)
            if (cust) {
              item['Customer'] = cust.title
            }
            let site = vm.$root.sites.find(c => c.value === printer.SiteKey)
            if (site) {
              item['Site'] = site.title
            }
            item.PageCount = parseInt(printer.PageCount, 10)
            item.A4Black = parseInt(printer.A4Black, 10)
            item.A4Color = parseInt(printer.A4Color, 10)
            item.A3Black = parseInt(printer.A3Black, 10)
            item.A3Color = parseInt(printer.A3Color, 10)
            item.BlackTonerLeft = vm.parseTonerLeft(printer.BlackTonerLeft, 10)
            item.CyanTonerLeft = vm.parseTonerLeft(printer.CyanTonerLeft, 10)
            item.MagentaTonerLeft = vm.parseTonerLeft(printer.MagentaTonerLeft, 10)
            item.YellowTonerLeft = vm.parseTonerLeft(printer.YellowTonerLeft, 10)
            if (printer.IsRefresh === 'Ready') {
              starCountRef.off('value', listener)
            }
          })
        }
          // vm.$root.refreshPrintersList.push({ MAC: item.MacAddress, Time: vm.$moment().format('YYYY-MM-DD HH:mm:ss') })
        if (vm.$root.timer === null) {
          // vm.$root.timer = setInterval(vm.$root.resetRefreshPrinters, (1000 * 60 * 1)) // 10 sec
        }
      },
      reloadPrinters () {
        const vm = this
        console.log('reloadPrinters...')
        console.log('this.$root.filter.dealerKey = ' + vm.$root.filter.dealerKey)
        console.log('this.$route.params.customerKey = ' + vm.$route.params.customerKey)
        console.log('this.$route.params.siteKey = ' + vm.$route.params.siteKey)
        console.log('this.$route.params.statusFilter = ' + vm.$route.params.statusFilter)

        if (this.$route.params.statusFilter && this.$route.params.statusFilter.length > 0) {
          if (this.$route.params.statusFilter !== 'NA') {
            this.hasFilter = true
            this.showAllPrinters = true
          } else {
            this.hasFilter = false
          }
        } else {
          this.hasFilter = false
        }

        vm.isLoading = true
        vm.getTitle()
        vm.printers = []
        vm.resetTimer = setInterval(vm.resetCurrentPrinters, vm.timerCountDown)
        if (vm.$root.isAdmin && vm.showAllPrinters) {
          console.log('this.$root.isAdmin = ' + vm.$root.isAdmin)
          // vm.loadAllPrinters()
        } else {
          if (vm.$route.params.customerKey) {
            if (vm.$route.params.siteKey && vm.$route.params.siteKey !== 'All') {
              if (vm.IsDbMoved) { vm.loadSitePrinters() } else { vm.loadSitePrinters_OLD() }
            } else {
              if (vm.IsDbMoved) { vm.loadCustomerPrinters() } else { vm.loadCustomerPrinters_OLD() }
            }
          }
        }
      },
      getTitle () {
        console.log('getTitle()...')
        const vm = this
        vm.titleCustomerSite = ''
        // vm.titleCustomerSite = vm.$route.params.customerKey
        if (vm.$route.params.customerKey) {
          if (vm.$route.params.siteKey && vm.$route.params.siteKey !== 'All') {
            // vm.titleCustomerSite = customerKey + siteKey
            for (let i = 0; i < vm.$root.slideItems.length; i++) {
              if (vm.$root.slideItems[i].type === 'tree' && vm.$root.slideItems[i].key === vm.$route.params.customerKey) {
                vm.titleCustomerSite = vm.$root.slideItems[i].FullName
                if (vm.$root.slideItems[i].items && vm.$root.slideItems[i].items.length > 0) {
                  for (let j = 0; j < vm.$root.slideItems[i].items.length; j++) {
                    if (vm.$root.slideItems[i].items[j].key === vm.$route.params.siteKey) {
                      vm.titleCustomerSite = vm.titleCustomerSite + ' > ' + vm.$root.slideItems[i].items[j].FullName
                      break
                    }
                  }
                  break
                }
              }
            }
          } else {
            for (let i = 0; i < vm.$root.slideItems.length; i++) {
              if (vm.$root.slideItems[i].type === 'tree' && vm.$root.slideItems[i].key === vm.$route.params.customerKey) {
                vm.titleCustomerSite = vm.$root.slideItems[i].FullName
                break
              }
            }
          }
        }
      },
      parseTonerLeft (colorLeft) {
        // let colorLeftPercent = ''
        let colorLeftInt = 0
        if (colorLeft && colorLeft.length > 0) {
          if (colorLeft.indexOf('-') >= 0) {
            colorLeftInt = 0
          }
          colorLeft = colorLeft.replace('%', '')
          colorLeft = colorLeft.split('.')[0]
          colorLeftInt = parseInt(colorLeft, 10)
        } else {
          colorLeftInt = -1
          // colorLeftInt = 0.000
          // colorLeftInt = ''
        }
        if (colorLeftInt > 100) { colorLeftInt = 100 }
        // if (colorLeftInt < 0) { colorLeftInt = 0 }
        if (isNaN(colorLeftInt)) {
          colorLeftInt = 0
        }
        return colorLeftInt
        // colorLeftPercent = colorLeftInt + '%'
        // return colorLeftPercent
      },
      loadCustomerPrinters () {
        console.log('loadCustomerPrinters...')
        const vm = this
        vm.isLoading = true
        let dealerCustomerKey = vm.$root.filter.dealerKey + '_' + vm.$route.params.customerKey
        let printersRef = dbStore.collection('DealerCustomerKey').where('DealerKey', '==', dealerCustomerKey)
        printersRef.get().then(function (snapPrinters) {
          vm.printers = []
          console.log('snapPrinters.size = ' + snapPrinters.size)
          if (snapPrinters.size > 0) {
            snapPrinters.forEach(function (result) {
              let printer = result.data()
              printer['DocID'] = result.id
              printer.PageCount = parseInt(printer.PageCount, 10)
              printer.A4Black = parseInt(printer.A4Black, 10)
              printer.A4Color = parseInt(printer.A4Color, 10)
              printer.A3Black = parseInt(printer.A3Black, 10)
              printer.A3Color = parseInt(printer.A3Color, 10)
              printer.BlackTonerLeft = vm.parseTonerLeft(printer.BlackTonerLeft, 10)
              printer.CyanTonerLeft = vm.parseTonerLeft(printer.CyanTonerLeft, 10)
              printer.MagentaTonerLeft = vm.parseTonerLeft(printer.MagentaTonerLeft, 10)
              printer.YellowTonerLeft = vm.parseTonerLeft(printer.YellowTonerLeft, 10)

              printer['Filter'] = vm.parseStatus(vm, printer.Status, printer.ErrorString)
              if (vm.hasFilter) {
                if (vm.$route.params.statusFilter === printer['Filter']) {
                  vm.printers.push(printer)
                }
              } else {
                vm.printers.push(printer)
              }
            })
          } else {
            console.log('loadDealerPrinters NO DATA !!')
            vm.printers = []
          }
          vm.isLoading = false
        })
      },
      loadCustomerPrinters_OLD () {
        console.log('loadCustomerPrinters...')
        const vm = this
        vm.loadCustomerPrintersDeleted()
        vm.isLoading = true
        let printersPath = 'Printers'
        let printersRef = db.ref(printersPath)
        let dealerCustomerKey = vm.$root.filter.dealerKey + '_' + vm.$route.params.customerKey
        // printersRef.orderByChild('DealerCustomerKey').equalTo(dealerCustomerKey).on('value', (snapPrinters) => {
        printersRef.orderByChild('DealerCustomerKey').equalTo(dealerCustomerKey).once('value', (snapPrinters) => {
          vm.printers = []
          const data = snapPrinters.val()
          if (data) {
            const pritnerKeys = Object.keys(data)
            // vm.sites = data
            for (let i = 0; i < pritnerKeys.length; i++) {
              let pKey = pritnerKeys[i]
              let printer = data[pKey]
              printer['.key'] = pKey
              printer.MacAddress = printer.MacAddress ? printer.MacAddress : printer['.key']
              var today = vm.$moment()
              var logDay = vm.$moment(printer.Logged, 'YYYY-MM-DD HH:mm:ss')
              let diffDays = today.diff(logDay, 'days')
              // console.log('diffDays = ' + diffDays)
              printer.IsNew = (diffDays <= 14)
              let dealer = vm.$root.dealers.find(c => c.value === printer.DealerKey)
              if (dealer) {
                printer['Dealer'] = dealer.title
              }
              let cust = vm.$root.customers.find(c => c.value === printer.CustomerKey)
              if (cust) {
                printer['Customer'] = cust.title
              }
              let site = vm.$root.sites.find(c => c.value === printer.SiteKey)
              if (site) {
                printer['Site'] = site.title
              }
              printer.PageCount = parseInt(printer.PageCount, 10)
              printer.A4Black = parseInt(printer.A4Black, 10)
              printer.A4Color = parseInt(printer.A4Color, 10)
              printer.A3Black = parseInt(printer.A3Black, 10)
              printer.A3Color = parseInt(printer.A3Color, 10)
              printer.BlackTonerLeft = vm.parseTonerLeft(printer.BlackTonerLeft, 10)
              printer.CyanTonerLeft = vm.parseTonerLeft(printer.CyanTonerLeft, 10)
              printer.MagentaTonerLeft = vm.parseTonerLeft(printer.MagentaTonerLeft, 10)
              printer.YellowTonerLeft = vm.parseTonerLeft(printer.YellowTonerLeft, 10)

              printer['Filter'] = vm.parseStatus(vm, printer.Status, printer.ErrorString)
              if (vm.hasFilter) {
                if (vm.$route.params.statusFilter === printer['Filter']) {
                  vm.printers.push(printer)
                }
              } else {
                vm.printers.push(printer)
              }
            }
            vm.isLoading = false
          } else {
            vm.isLoading = false
          }
        })
      },
      // Abed Ali
      // 09/02/2023
      loadCustomerPrintersDeleted () {
        console.log('loadCustomerPrintersDeleted...')
        const vm = this
        vm.isLoading = true
        let printersDeletedPath = 'DeletedPrinters'
        let printersDeletedRef = db.ref(printersDeletedPath)
        printersDeletedRef.orderByChild('CustomerKey').equalTo(vm.$route.params.customerKey).once('value', (snapPrinters) => {
          vm.printersDeleted = []
          const data = snapPrinters.val()
          if (data) {
            const pritnerKeys = Object.keys(data)
            // vm.sites = data
            for (let i = 0; i < pritnerKeys.length; i++) {
              let pKey = pritnerKeys[i]
              let printer = data[pKey]
              printer['.key'] = pKey
              printer.MacAddress = printer.MacAddress ? printer.MacAddress : printer['.key']
              var today = vm.$moment()
              var logDay = vm.$moment(printer.Logged, 'YYYY-MM-DD HH:mm:ss')
              let diffDays = today.diff(logDay, 'days')
              // console.log('diffDays = ' + diffDays)
              printer.IsNew = (diffDays <= 14)
              let dealer = vm.$root.dealers.find(c => c.value === printer.DealerKey)
              if (dealer) {
                printer['Dealer'] = dealer.title
              }
              let cust = vm.$root.customers.find(c => c.value === printer.CustomerKey)
              if (cust) {
                printer['Customer'] = cust.title
              }
              let site = vm.$root.sites.find(c => c.value === printer.SiteKey)
              if (site) {
                printer['Site'] = site.title
              }
              // Deleted
              printer.Status = 'Deleted'
              vm.printersDeleted.push(printer)
            }
            vm.isLoading = false
          } else {
            vm.isLoading = false
          }
        })
      },
      // Abed Ali
      // 02/02/2023
      // Ready - working OK with FireStore / Just need to test effect on other models
      loadSitePrinters () {
        console.log('loadSitePrinters...')
        const vm = this
        vm.isLoading = true
        let dealerCustomerSiteKey = vm.$root.filter.dealerKey + '_' + vm.$route.params.customerKey + '_' + vm.$route.params.siteKey
        let printersRef = dbStore.collection('Printers').where('DealerCustomerSiteKey', '==', dealerCustomerSiteKey)
        printersRef.get().then(function (snapPrinters) {
          vm.printers = []
          console.log('snapPrinters.size = ' + dealerCustomerSiteKey)
          console.log('AAXXTEST ')
          console.log('snapPrinters.size = ' + snapPrinters.size)
          if (snapPrinters.size > 0) {
            snapPrinters.forEach(function (result) {
              let printer = result.data()
              printer['DocID'] = result.id
              printer.PageCount = parseInt(printer.PageCount, 10)
              printer.A4Black = parseInt(printer.A4Black, 10)
              printer.A4Color = parseInt(printer.A4Color, 10)
              printer.A3Black = parseInt(printer.A3Black, 10)
              printer.A3Color = parseInt(printer.A3Color, 10)
              printer.BlackTonerLeft = vm.parseTonerLeft(printer.BlackTonerLeft, 10)
              printer.CyanTonerLeft = vm.parseTonerLeft(printer.CyanTonerLeft, 10)
              printer.MagentaTonerLeft = vm.parseTonerLeft(printer.MagentaTonerLeft, 10)
              printer.YellowTonerLeft = vm.parseTonerLeft(printer.YellowTonerLeft, 10)
              printer['Filter'] = vm.parseStatus(vm, printer.Status, printer.ErrorString)
              if (vm.hasFilter) {
                if (vm.$route.params.statusFilter === printer['Filter']) {
                  vm.printers.push(printer)
                }
              } else {
                vm.printers.push(printer)
              }
            })
          } else {
            console.log('printersHistory NO DATA !!')
            vm.printers = []
          }
          vm.isLoading = false
        })
      },
      // Abed Ali
      // 02/02/2023
      // Renamed from loadSitePrinters to loadSitePrinters_OLD
      loadSitePrinters_OLD () {
        console.log('loadSitePrinters...')
        const vm = this
        vm.loadSitePrintersDeleted()
        vm.isLoading = true
        let printersPath = 'Printers'
        let printersRef = db.ref(printersPath)
        let dealerCustomerSiteKey = vm.$root.filter.dealerKey + '_' + vm.$route.params.customerKey + '_' + vm.$route.params.siteKey
        // printersRef.orderByChild('DealerCustomerSiteKey').equalTo(dealerCustomerSiteKey).on('value', (snapPrinters) => {
        printersRef.orderByChild('DealerCustomerSiteKey').equalTo(dealerCustomerSiteKey).once('value', (snapPrinters) => {
          vm.printers = []
          const data = snapPrinters.val()
          if (data) {
            const pritnerKeys = Object.keys(data)
            // vm.sites = data
            for (let i = 0; i < pritnerKeys.length; i++) {
              let pKey = pritnerKeys[i]
              let printer = data[pKey]
              printer['.key'] = pKey
              printer.MacAddress = printer.MacAddress ? printer.MacAddress : printer['.key']
              var today = vm.$moment()
              var logDay = vm.$moment(printer.Logged, 'YYYY-MM-DD HH:mm:ss')
              let diffDays = today.diff(logDay, 'days')
              printer.IsNew = (diffDays <= 14)
              let dealer = vm.$root.dealers.find(c => c.value === printer.DealerKey)
              if (dealer) {
                printer['Dealer'] = dealer.title
              }
              let cust = vm.$root.customers.find(c => c.value === printer.CustomerKey)
              if (cust) {
                printer['Customer'] = cust.title
              }
              let site = vm.$root.sites.find(c => c.value === printer.SiteKey)
              if (site) {
                printer['Site'] = site.title
              }
              printer.PageCount = parseInt(printer.PageCount, 10)
              printer.A4Black = parseInt(printer.A4Black, 10)
              printer.A4Color = parseInt(printer.A4Color, 10)
              printer.A3Black = parseInt(printer.A3Black, 10)
              printer.A3Color = parseInt(printer.A3Color, 10)
              printer.BlackTonerLeft = vm.parseTonerLeft(printer.BlackTonerLeft, 10)
              printer.CyanTonerLeft = vm.parseTonerLeft(printer.CyanTonerLeft, 10)
              printer.MagentaTonerLeft = vm.parseTonerLeft(printer.MagentaTonerLeft, 10)
              printer.YellowTonerLeft = vm.parseTonerLeft(printer.YellowTonerLeft, 10)
              printer['Filter'] = vm.parseStatus(vm, printer.Status, printer.ErrorString)
              if (vm.hasFilter) {
                if (vm.$route.params.statusFilter === printer['Filter']) {
                  vm.printers.push(printer)
                }
              } else {
                vm.printers.push(printer)
              }
            }
          } else {
          }
          vm.isLoading = false
        })
      },
      loadSitePrintersDeleted () {
        console.log('loadSitePrintersDeleted...')
        const vm = this
        vm.isLoading = true
        let printersDeletedPath = 'DeletedPrinters'
        let printersDeletedRef = db.ref(printersDeletedPath)
        printersDeletedRef.orderByChild('SiteKey').equalTo(vm.$route.params.siteKey).once('value', (snapPrinters) => {
          vm.printersDeleted = []
          const data = snapPrinters.val()
          if (data) {
            const pritnerKeys = Object.keys(data)
            // vm.sites = data
            for (let i = 0; i < pritnerKeys.length; i++) {
              let pKey = pritnerKeys[i]
              let printer = data[pKey]
              printer['.key'] = pKey
              printer.MacAddress = printer.MacAddress ? printer.MacAddress : printer['.key']
              var today = vm.$moment()
              var logDay = vm.$moment(printer.Logged, 'YYYY-MM-DD HH:mm:ss')
              let diffDays = today.diff(logDay, 'days')
              printer.IsNew = (diffDays <= 14)
              let dealer = vm.$root.dealers.find(c => c.value === printer.DealerKey)
              if (dealer) {
                printer['Dealer'] = dealer.title
              }
              let cust = vm.$root.customers.find(c => c.value === printer.CustomerKey)
              if (cust) {
                printer['Customer'] = cust.title
              }
              let site = vm.$root.sites.find(c => c.value === printer.SiteKey)
              if (site) {
                printer['Site'] = site.title
              }
              printer.Status = 'Deleted'
              vm.printersDeleted.push(printer)
            }
          } else {
          }
          vm.isLoading = false
        })
      },
      // Abed Ali
      // 092/02/2023
      // Ready - working OK with FireStore / Just need to test effect on other models
      loadDealerPrinters_OLD () {
        console.log('loadDealerPrinters...')
        const vm = this
        vm.isLoading = true
        let printersRef = dbStore.collection('Printers').where('DealerKey', '==', vm.$root.filter.dealerKey)
        printersRef.get().then(function (snapPrinters) {
          vm.printers = []
          console.log('snapPrinters.size = ' + snapPrinters.size)
          if (snapPrinters.size > 0) {
            snapPrinters.forEach(function (result) {
              let printer = result.data()
              printer['DocID'] = result.id
              printer.PageCount = parseInt(printer.PageCount, 10)
              printer.A4Black = parseInt(printer.A4Black, 10)
              printer.A4Color = parseInt(printer.A4Color, 10)
              printer.A3Black = parseInt(printer.A3Black, 10)
              printer.A3Color = parseInt(printer.A3Color, 10)
              printer.BlackTonerLeft = vm.parseTonerLeft(printer.BlackTonerLeft, 10)
              printer.CyanTonerLeft = vm.parseTonerLeft(printer.CyanTonerLeft, 10)
              printer.MagentaTonerLeft = vm.parseTonerLeft(printer.MagentaTonerLeft, 10)
              printer.YellowTonerLeft = vm.parseTonerLeft(printer.YellowTonerLeft, 10)
              printer['Filter'] = vm.parseStatus(vm, printer.Status, printer.ErrorString)
              if (vm.hasFilter) {
                if (vm.$route.params.statusFilter === printer['Filter']) {
                  vm.printers.push(printer)
                }
              } else {
                vm.printers.push(printer)
              }
            })
          } else {
            console.log('loadDealerPrinters NO DATA !!')
            vm.printers = []
          }
          vm.isLoading = false
        })
      },
      loadDealerPrinters () {
        console.log('loadDealerPrinters...')
        const vm = this
        vm.isLoading = true
        let printersPath = 'Printers'
        let printersRef = db.ref(printersPath)
        // printersRef.orderByChild('DealerKey').equalTo(vm.$root.filter.dealerKey).on('value', (snapPrinters) => {
        printersRef.orderByChild('DealerKey').equalTo(vm.$root.filter.dealerKey).once('value', (snapPrinters) => {
          vm.printers = []
          const data = snapPrinters.val()
          if (data) {
            const pritnerKeys = Object.keys(data)
            // vm.sites = data
            for (let i = 0; i < pritnerKeys.length; i++) {
              let pKey = pritnerKeys[i]
              let printer = data[pKey]
              printer['.key'] = pKey
              printer.MacAddress = printer.MacAddress ? printer.MacAddress : printer['.key']
              var today = vm.$moment()
              var logDay = vm.$moment(printer.Logged, 'YYYY-MM-DD HH:mm:ss')
              let diffDays = today.diff(logDay, 'days')
              printer.IsNew = (diffDays <= 14)
              let cust = vm.$root.customers.find(c => c.value === printer.CustomerKey)
              let dealer = vm.$root.dealers.find(c => c.value === printer.DealerKey)
              if (dealer) {
                printer['Dealer'] = dealer.title
              }
              if (cust) {
                printer['Customer'] = cust.title
              }
              let site = vm.$root.sites.find(c => c.value === printer.SiteKey)
              if (site) {
                printer['Site'] = site.title
              }
              printer.PageCount = parseInt(printer.PageCount, 10)
              printer.A4Black = parseInt(printer.A4Black, 10)
              printer.A4Color = parseInt(printer.A4Color, 10)
              printer.A3Black = parseInt(printer.A3Black, 10)
              printer.A3Color = parseInt(printer.A3Color, 10)
              printer.BlackTonerLeft = vm.parseTonerLeft(printer.BlackTonerLeft, 10)
              printer.CyanTonerLeft = vm.parseTonerLeft(printer.CyanTonerLeft, 10)
              printer.MagentaTonerLeft = vm.parseTonerLeft(printer.MagentaTonerLeft, 10)
              printer.YellowTonerLeft = vm.parseTonerLeft(printer.YellowTonerLeft, 10)
              console.log('printer.Status = ' + printer.Status)
              console.log('printer.ErrorString = ' + printer.ErrorString)
              printer['Filter'] = vm.parseStatus(vm, printer.Status, printer.ErrorString)
              console.log('printer.Filter = ' + printer['Filter'])
              if (vm.hasFilter) {
                if (vm.$route.params.statusFilter === printer['Filter']) {
                  vm.printers.push(printer)
                }
              } else {
                vm.printers.push(printer)
              }
            }
            // console.log(vm.printers)
            console.log(JSON.stringify(vm.printers))
          } else {
          }
          vm.isLoading = false
        })
      },
      loadAllPrinters () {
        console.log('loadAllPrinters...')
        const vm = this
        vm.isLoading = true
        let printersPath = 'Printers'
        let printersRef = db.ref(printersPath)
        // printersRef.on('value', function (snapshot) {
        printersRef.once('value', function (snapshot) {
          console.log('All printersRef.once(value)...')
          vm.printers = []
          const data = snapshot.val()
          if (data) {
            const pritnerKeys = Object.keys(data)
            // vm.sites = data
            for (let i = 0; i < pritnerKeys.length; i++) {
              let pKey = pritnerKeys[i]
              let printer = data[pKey]
              printer['.key'] = pKey
              printer.MacAddress = printer.MacAddress ? printer.MacAddress : printer['.key']
              var today = vm.$moment()
              var logDay = vm.$moment(printer.Logged, 'YYYY-MM-DD HH:mm:ss')
              let diffDays = today.diff(logDay, 'days')
              printer.IsNew = (diffDays <= 14)
              let dealer = vm.$root.dealers.find(c => c.value === printer.DealerKey)
              if (dealer) {
                printer['Dealer'] = dealer.title
              }
              let cust = vm.$root.customers.find(c => c.value === printer.CustomerKey)
              if (cust) {
                printer['Customer'] = cust.title
              }
              let site = vm.$root.sites.find(c => c.value === printer.SiteKey)
              if (site) {
                printer['Site'] = site.title
              }
              printer.PageCount = parseInt(printer.PageCount, 10)
              printer.A4Black = parseInt(printer.A4Black, 10)
              printer.A4Color = parseInt(printer.A4Color, 10)
              printer.A3Black = parseInt(printer.A3Black, 10)
              printer.A3Color = parseInt(printer.A3Color, 10)
              printer.BlackTonerLeft = vm.parseTonerLeft(printer.BlackTonerLeft, 10)
              printer.CyanTonerLeft = vm.parseTonerLeft(printer.CyanTonerLeft, 10)
              printer.MagentaTonerLeft = vm.parseTonerLeft(printer.MagentaTonerLeft, 10)
              printer.YellowTonerLeft = vm.parseTonerLeft(printer.YellowTonerLeft, 10)
              printer['Filter'] = vm.parseStatus(vm, printer.Status, printer.ErrorString)
              if (vm.hasFilter) {
                if (vm.$route.params.statusFilter === printer['Filter']) {
                  vm.printers.push(printer)
                }
              } else {
                vm.printers.push(printer)
              }
            }
          } else {
          }
          vm.isLoading = false
        })
        // var starCountRef = firebase.database().ref('posts/' + postId + '/starCount')
        // starCountRef.on('value', function (snapshot) {
        //   updateStarCount(postElement, snapshot.val())
        // })
      },
      parseStatus (vm, status, errorString) {
        console.log('parseStatus() started...')
        let filter = vm.parseStatusOnly(status)
        if (filter && filter.length > 0) {
          console.log('filter1 = ' + filter)
          return filter
        } else {
          filter = vm.parseStatusOnly(errorString)
          if (filter && filter.length > 0) {
            console.log('filter2 = ' + filter)
            return filter
          } else {
            filter = 'Unknown'
            console.log('filter3 = ' + filter)
            return filter
          }
        }
      },
      parseStatusOnly (status) {
        if (status === true) { return 'Online' }
        if (status === false) { return 'Offline' }
        if (status === 'Deleted') { return 'Errors' }
        if (status) {
          if (status.trim().toLowerCase().indexOf('ready') > -1) { return 'Online' }
          if (status.trim().toLowerCase().indexOf('sleep') > -1) { return 'Online' }
          if (status.trim().toLowerCase().indexOf('idle') > -1) { return 'Online' }
          if (status.trim().toLowerCase().indexOf('connect') > -1) {
            if (status.trim().toLowerCase().indexOf('disconnect') > -1) {
              return 'Offline'
            } else {
              return 'Online'
            }
          }
          if (status.trim().toLowerCase().indexOf('online') > -1) { return 'Online' }
          if (status.trim().toLowerCase().indexOf('sleep') > -1) { return 'Online' }
          if (status.trim().toLowerCase().indexOf('energy') > -1) {
            if (status.trim().toLowerCase().indexOf('save') > -1) { return 'Online' }
          }
          if (status.trim().toLowerCase().indexOf('power') > -1) {
            if (status.trim().toLowerCase().indexOf('save') > -1) { return 'Online' }
            if (status.trim().toLowerCase().indexOf('mode') > -1) { return 'Online' }
          }
          if (status.trim().toLowerCase().indexOf('printing') > -1) { return 'Online' }
          if (status.trim().toLowerCase().indexOf('paper') > -1) {
            if (status.trim().toLowerCase().indexOf('out') > -1) { return 'OutOfPaper' }
            if (status.trim().toLowerCase().indexOf('low') > -1) { return 'OutOfPaper' }
            if (status.trim().toLowerCase().indexOf('of') > -1) { return 'OutOfPaper' }
            return 'OutOfPaper'
          }

          if (status.trim().toLowerCase().indexOf('toner') > -1) {
            if (status.trim().toLowerCase().indexOf('low') > -1) { return 'LowToner' }
            if (status.trim().toLowerCase().indexOf('out') > -1) { return 'LowToner' }
            if (status.trim().toLowerCase().indexOf('replace') > -1) { return 'LowToner' }
            return 'LowToner'
          }

          if (status.trim().toLowerCase().indexOf('error') > -1) {
            if (status.trim().toLowerCase().indexOf('has') > -1) { return 'Errors' }
            return 'Errors'
          }

          // printer.ErrorString
          switch (status.trim().toLowerCase()) {
            case 'online': return 'Online'
            case 'idle(3)': return 'Online'
            case 'connected': return 'Online'
            case 'ready': return 'Online'
            case 'offline': return 'Offline'
            case 'disconnected': return 'Offline'
            case 'sleep': return 'Online'
            case 'energy saver mode': return 'Online'
            case 'power saver': return 'Online'
            case 'powersave on': return 'Online'
            case 'power down mode.': return 'Online'
            case 'outofpaper': return 'OutOfPaper'
            case 'lowpaper': return 'OutOfPaper'
            case 'lowtoner': return 'LowToner'
            case 'error': return 'Errors'
            case 'fail': return 'Errors'
            case 'jam': return 'Errors'
            default: return null
          }
        } else {
          return null
        }
      },
      fillTonerHistory () {
        console.log('Admin Fill Toner History (Demo) ')
        let vm = this
        let printer = vm.printers.find(function (row) {
          if (row.MacAddress === '00-68-EB-4E-91-39') {
            return row
          }
        })
        // TonerHistory/Dealers/peQNUIFI12UqGLz70fUEwbsKqrx1/Customers/-MOjheVAIyoqVYXPS5-6/Printers/F4-30-B9-6F-B3-20
        // TonerHistory/Dealers/peQNUIFI12UqGLz70fUEwbsKqrx1/Customers/-MOjheVAIyoqVYXPS5-6/Printers/F4-30-B9-6F-B3-20/BlackToners/1/{doc_data}
        // TonerHistory/Dealers/peQNUIFI12UqGLz70fUEwbsKqrx1/Customers/-MOjheVAIyoqVYXPS5-6/Printers/F4-30-B9-6F-B3-20/BlackToners/2/{doc_data}
        // TonerHistory/Dealers/peQNUIFI12UqGLz70fUEwbsKqrx1/Customers/-MOjheVAIyoqVYXPS5-6/Printers/F4-30-B9-6F-B3-20/CyanToners/1/{doc_data}
        // TonerHistory/Dealers/peQNUIFI12UqGLz70fUEwbsKqrx1/Customers/-MOjheVAIyoqVYXPS5-6/Printers/F4-30-B9-6F-B3-20/MagentaToners/1/{doc_data}
        // TonerHistory/Dealers/peQNUIFI12UqGLz70fUEwbsKqrx1/Customers/-MOjheVAIyoqVYXPS5-6/Printers/F4-30-B9-6F-B3-20/YellowToners/1/{doc_data}
        // IsExist()
        // TonerHistory/Dealers/peQNUIFI12UqGLz70fUEwbsKqrx1/Customers/-MOjheVAIyoqVYXPS5-6/Printers/F4-30-B9-6F-B3-20
        if (printer) {
          // {doc_data} =
          let tonerData = {
            StartLogged: printer.Logged,
            StartToner: Number(printer.PageCount),
            StartCounter: Number(printer.PageCount),
            EndLogged: printer.Logged,
            EndToner: Number(printer.PageCount),
            EndCounter: Number(printer.PageCount),
            SiteKey: printer.SiteKey,
            DiffCounter: 0
          }
          console.log(tonerData)
          // CollectionPath =
          let tonerCollectionPath = ''
          tonerCollectionPath += '/TonerHistory/'
          tonerCollectionPath += 'Dealers/'
          tonerCollectionPath += printer.DealerKey + '/'
          tonerCollectionPath += 'Customers/'
          tonerCollectionPath += printer.CustomerKey + '/'
          tonerCollectionPath += 'Printers/'
          tonerCollectionPath += printer.MacAddress + '/'
          console.log(tonerCollectionPath)
          tonerCollectionPath = '/TonerHistory/Dealers/peQNUIFI12UqGLz70fUEwbsKqrx1/Customers/-MOjheVAIyoqVYXPS5-6/Printers/00-68-EB-4E-91-39/'
          console.log(tonerCollectionPath)
          let arr = []
          arr.push(tonerData)
          // arr.push(tonerData)
          // arr.push(tonerData)
          let tonerObj = {
            Black: [],
            Cyan: [],
            Magenta: [],
            Yellow: []
          }
          console.log(tonerObj)
          dbStore.collection(tonerCollectionPath).doc('Toners').get().then((result) => {
            console.log(result)
          }).catch((error) => {
            console.log('Error getting document:', error)
          })
          // dbStore.collection(tonerCollectionPath).doc('Toners/').set(tonerObj)
          /*
          dbStore.collection(tonerCollectionPath).doc('Toners').update({
            Yellow: 100
          })
          */
          dbStore.collection(tonerCollectionPath).get().then((result) => {
            console.log(result)
            if (result.size > 0) {
              let item = result.docs[0].data()
              console.log(item)
            } else {
            }
          }).catch((error) => {
            console.log('Error getting document:', error)
          })
        }
      },
      resetAllPrintersAdmin () {
        console.log('Admin Reset All Printers ')
        let printersPath = 'Printers'
        let printersRef = db.ref(printersPath)
        printersRef.once('value', function (snapshot) {
          const data = snapshot.val()
          if (data) {
            const pritnerKeys = Object.keys(data)
            console.log(pritnerKeys)
            for (let i = 0; i < pritnerKeys.length; i++) {
              let pKey = pritnerKeys[i]
              let printer = data[pKey]
              try {
                printer['.key'] = pKey
                if (printer.IsRefresh !== 'Ready') {
                  console.log(printer.MacAddress + ' >>> ' + printer.SiteKey)
                  db.ref('Printers/' + printer.MacAddress + '/IsRefresh').set('Ready')
                }
              } catch (e) {
                console.log('Error ::: ' + printer.MacAddress + ' >>> ' + printer.SiteKey)
              }
            }
          }
        })
      },
      refreshAllPrintersAdmin () {
        // let vm = this
        console.log('Admin Refresh All Printer ')
        let printersPath = 'Printers'
        let printersRef = db.ref(printersPath)
        printersRef.once('value', function (snapshot) {
          const data = snapshot.val()
          if (data) {
            const pritnerKeys = Object.keys(data)
            console.log(pritnerKeys)
            for (let i = 0; i < pritnerKeys.length; i++) {
              let pKey = pritnerKeys[i]
              let printer = data[pKey]
              try {
                printer['.key'] = pKey
                console.log(printer.MacAddress + ' >>> ' + printer.SiteKey)
                dbListener.ref('RefreshPrinter/' + printer.SiteKey + '/' + printer.MacAddress).set(true)
              } catch (e) {
                console.log('Error ::: ' + printer.MacAddress + ' >>> ' + printer.SiteKey)
              }
            }
          }
        })
      },
      getPercent (colorLeft) {
        if (colorLeft && colorLeft.length > 0) {
          if (colorLeft.indexOf('-') >= 0) {
            return '0%'
          }
          colorLeft = colorLeft.replace('%', '')
          colorLeft = colorLeft.split('.')[0]
          return colorLeft + '%'
        } else {
          return '0%'
        }
      },
      getStatusColor (status) {
        if (status) {
          switch (status.trim().toLowerCase()) {
            case 'online': return 'green'
            case 'connected': return 'green'
            case 'ready': return 'green'
            case 'offline': return 'red'
            case 'disconnected': return 'red'
            case 'sleep': return 'red'
            default: return 'darkorange'
          }
        } else {
          return 'darkorange'
        }
      },
      edit (item) {
        this.$bus.$emit('customerModal-open', item)
      },
      info (item) {
        const vm = this
        // alert(JSON.stringify(item))
        // this.$bus.$emit('printerInfoModal-open')
        vm.$bus.$emit('printerInfoModal-open', item)
      },
      history (item) {
        const vm = this
        // alert(JSON.stringify(item))
        // this.$bus.$emit('printerInfoModal-open')
        vm.$bus.$emit('printerInfoModal-open', item)
      },
      editCode (item) {
        console.log(item['.key'])
        console.log(item['DeviceCode'])
        // let vm = this
        let deviceCode = prompt('Please enter [Device Code] : ', item['DeviceCode'])
        if (deviceCode != null) {
          console.log('New Device Code: ' + deviceCode)
          db.ref('Printers/' + item['.key'] + '/DeviceCode').set(deviceCode)
        }
      },
      confirmDelete (item) {
        const vm = this
        vm.$bus.$emit('modal-open', {
          title: 'Delete Printer',
          description: 'Are you sure you want to delete printer [' + item['.key'] + ']',
          type: 'modal-primary',
          confirmText: 'Delete',
          cancelText: 'Cancel',
          confirmBefore: () => {
            console.log('[DeletePrinter] >>> confirmBefore')
          },
          confirmAfter: () => {
            console.log('[DeletePrinter] >>> confirmAfter')
            const printerRef = db.ref('Printers/' + item['.key'])
            console.log('Printers/' + item['.key'])
            printerRef.remove().then(function (data) {
              console.log(data)
              let deletedPrinter = {
                MacAddress: item.MacAddress,
                IPAddress: item.IPAddress,
                Location: item.Location,
                PrinterName: item.PrinterName,
                ModelName: item.ModelName,
                PrinterSerial: item.PrinterSerial,
                UID: item.UID,
                SiteKey: item.SiteKey,
                CustomerKey: item.CustomerKey,
                DealerKey: item.DealerKey
              }
              const deletedPrinterRef = db.ref('DeletedPrinters/' + deletedPrinter.MacAddress)
              deletedPrinterRef.set(deletedPrinter)
              let countersData = {
                Value: -1,
                CounterName: 'TotalPrinters',
                DealerKey: item.DealerKey,
                CustomerKey: item.CustomerKey,
                SiteKey: item.SiteKey
              }
              vm.$UpdateCounters(countersData, function (result) {
                console.log(result)
              })
              vm.updateClientDeletePrinter(item)
              vm.reloadPrinters()
            })
          },
          cancelBefore: () => {
            console.log('[DeletePrinter] >>> cancelBefore')
          },
          cancelAfter: () => {
            console.log('[DeletePrinter] >>> cancelAfter')
          }
        })
      },
      restorePrinter (item) {
        let vm = this
        console.log('restorePrinter (' + item['.key'] + ')')
        console.log(item)
        let deletedPrinterPath = 'DeletedPrinters/' + item['.key']
        let copyDeletedPritner = {
          MacAddress: item.MacAddress,
          IPAddress: item.IPAddress,
         // IPAddress: item.IPAddress,
          PrinterName: item.PrinterName,
          ModelName: item.ModelName,
          PrinterSerial: item.PrinterSerial,
          UID: item.UID,
          SiteKey: item.SiteKey,
          CustomerKey: item.CustomerKey,
          DealerKey: item.DealerKey
        }
        console.log(copyDeletedPritner)
        db.ref(deletedPrinterPath).remove().then(function (data) {
          console.log(JSON.stringify(vm.deletedPrinter))
          vm.updateClientRestorePrinter(copyDeletedPritner)
        })
        setTimeout(() => {
          vm.reloadPrinters()
        }, 1000)
      },
      updateClientRestorePrinter (item) {
        console.log('updateClientRestorePrinter(' + item.MacAddress + ')')
        dbListener.ref('UpdateClient/' + item.SiteKey + '/RestorePrinters').once('value').then(function (snapData) {
          let strData = snapData.val()
          console.log('strData: ' + strData)
          if (strData) {
            strData = strData.toLowerCase()
            let arr = strData.split(',')
            if (arr && arr.length > 0) {
              let index = arr.indexOf(item.MacAddress.toLowerCase())
              if (index === -1) {
                arr.push(item.MacAddress)
                strData = arr.join(',')
                dbListener.ref('UpdateClient/' + item.SiteKey + '/RestorePrinters').set(strData).then(function () {
                  console.log('RestorePrinters [' + item.MacAddress + '] Was set to [Done].')
                  // location.reload(true)
                }).catch(function (error) {
                  console.log('Error: ' + error.message)
                })
              }
            }
          } else {
            dbListener.ref('UpdateClient/' + item.SiteKey + '/RestorePrinters').set(item.MacAddress)
          }
        })
      },
      updateClientDeletePrinter (item) {
        console.log('updateClientDeletePrinter(' + item.MacAddress + ')')
        dbListener.ref('UpdateClient/' + item.SiteKey + '/DeletePrinters').once('value').then(function (snapData) {
          let strData = snapData.val()
          if (strData) {
            strData = strData.toLowerCase()
            let arr = strData.split(',')
            if (arr && arr.length > 0) {
              let index = arr.indexOf(item.MacAddress.toLowerCase())
              if (index === -1) {
                arr.push(item.MacAddress)
                strData = arr.join(',')
                dbListener.ref('UpdateClient/' + item.SiteKey + '/DeletePrinters').set(strData).then(function () {
                  console.log(fieldName + 'Done [' + macAddress + '] Was set to [Done].')
                }).catch(function (error) {
                  console.log('Error: ' + error.message)
                })
              }
            }
          } else {
            dbListener.ref('UpdateClient/' + item.SiteKey + '/DeletePrinters').set(item.MacAddress)
          }
        })
      }
    }
  }
</script>
<style>
  .tabsMobile {
    padding: 10px 0px 10px 10px!important;
  }
</style>



// WEBPACK FOOTER //
// Printers.vue?e47b2522